// extracted by css-extract-rspack-plugin
export default {"attachmentRow":"attachmentRow-QwmcW3","attachmentLabel":"attachmentLabel-vRKJeh","hiddenLabel":"hiddenLabel-mIaJlo"};